
import { defineComponent } from "vue";
import "@/assets/scss/admin/add-doctor.scss";
import axios from "axios";
import DatePicker from "vue3-persian-datetime-picker";
import LoadingScreen from "@/components/LoadingScreen.vue";
export default defineComponent({
  components: { DatePicker, LoadingScreen },

  // eslint-disable-next-line vue/multi-word-component-names
  name: "add-patient",
  data() {
    return {
      isLoading: true,
      modal: false,
      patients: [],
      doctor: {},
      first_name: "",
      last_name: "",
      mobile: "",
      address: "",
      birthday: "",
      user_name: "",
      password: "",
      gender: "male",
      male: "male",
      famale: "famale",
      national_code: "",
      height: "",
      weight: "",
      blood_type: "",
      underlying_diseases: "",
      isNullFirsName: false,
      isNullLastName: false,
      isNullBirthday: false,
      isNullMobile: false,
      isNullNationalCode: false,
      isNullAddress: false,
      isNullUserName: false,
      isNullPassword: false,
      isNullHeight: false,
      isNullWeight: false,
      isNullUnderlying: false,
      isNullBlood_type: false,
    };
  },
  methods: {
    fetchPatients() {
      axios
        .get("/patients")
        .then((res) => {
          this.isLoading = false;
          // console.log(res.data);
          this.patients = res.data;
        })
        .catch((error) => {
          console.log(error.status);
        });
    },
    savePatient() {
      let sccess = false;
      if (this.first_name === "") {
        this.isNullFirsName = true;
      } else {
        this.isNullFirsName = false;
        sccess = true;
      }
      if (this.last_name === "") {
        this.isNullLastName = true;
      } else {
        this.isNullLastName = false;
        sccess = true;
      }
      if (this.birthday === "") {
        this.isNullBirthday = true;
      } else {
        this.isNullBirthday = false;
        sccess = true;
      }
      if (this.mobile === "") {
        this.isNullMobile = true;
      } else {
        this.isNullMobile = false;
        sccess = true;
      }
      if (this.national_code === "") {
        this.isNullNationalCode = true;
      } else {
        this.isNullNationalCode = false;
        sccess = true;
      }
      if (this.height === "") {
        this.isNullHeight = true;
      } else {
        this.isNullHeight = false;
        sccess = true;
      }
      if (this.weight === "") {
        this.isNullWeight = true;
      } else {
        this.isNullWeight = false;
        sccess = true;
      }
      if (this.blood_type === "") {
        this.isNullBlood_type = true;
      } else {
        this.isNullBlood_type = false;
        sccess = true;
      }
      if (this.underlying_diseases === "") {
        this.isNullUnderlying = true;
      } else {
        this.isNullUnderlying = false;
        sccess = true;
      }
      if (this.address === "") {
        this.isNullAddress = true;
      } else {
        this.isNullAddress = false;
        sccess = true;
      }
      if (this.user_name === "") {
        this.isNullUserName = true;
      } else {
        this.isNullUserName = false;
        sccess = true;
      }
      if (this.password === "") {
        this.isNullPassword = true;
      } else {
        this.isNullPassword = false;
        sccess = true;
      }
      if (
        sccess == true &&
        this.isNullFirsName == false &&
        this.isNullLastName == false &&
        this.isNullBirthday == false &&
        this.isNullMobile == false &&
        this.isNullNationalCode == false &&
        this.isNullAddress == false &&
        this.isNullUserName == false &&
        this.isNullPassword == false
      ) {
        axios
          .post("/patients", {
            first_name: this.first_name,
            last_name: this.last_name,
            birthday: this.birthday,
            gender: this.gender,
            mobile: this.mobile,
            height: this.height,
            weight: this.weight,
            underlying_diseases: this.underlying_diseases,
            blood_type: this.blood_type,
            address: this.address,
            national_code: this.national_code,
            username: this.user_name,
            password: this.password,
          })
          .then(() => {
            window.alert("بیمار با موفقیت ثبت شد");
            this.modal = false;
            this.fetchPatients();
            this.first_name = "";
            this.last_name = "";
            this.mobile = "";
            this.address = "";
            this.birthday = "";
            this.user_name = "";
            this.password = "";
            this.gender = "male";
            this.male = "male";
            this.famale = "famale";
            this.national_code = "";
            this.height = "";
            this.weight = "";
            this.blood_type = "";
            this.underlying_diseases = "";
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  mounted() {
    this.fetchPatients();
  },
});
